export const capitiliseFirstLetter = (string) => {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  }
  return null
}

export const getFilterDateString = (value) => {
  return value ? value.label : 'Unknown'
}

export const getPercentOf = (oldVal, newVal) => {
  if (!newVal) return '-'
  const value = (oldVal * 100) / newVal
  return (Math.round(value * 100) / 100) + '%'
}

export default {
  capitiliseFirstLetter
}



// WEBPACK FOOTER //
// ./src/utils/formatting.js